<template>
    <div class="page_not_found">
        お探しのページが見つかりません。<br>
        アドレスをお確かめのうえ、もう一度お試しください。
    </div>
</template>

<script>
    export default {
        name: "Error404"
    }
</script>

<style scoped lang="scss">
    .page_not_found{
        min-height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 2px 4px #d1d1d1 inset;
    }
</style>
